import React from 'react';
import '../css/ProfileCss.css'
import {
  Routes,
  Route,
  useNavigate
} from "react-router-dom";
// import AVATAR from '../images/avatar01.jpg'
import AVATAR from '../images/decidd/Admin.webp'
function Profile (props){
  let navigate = useNavigate();
    // const [token, setToken]= React.useState;
    // const logoutUser = () => {
    //     window.localStorage.clear();
    //  }
    const Name = localStorage.getItem('name');
  const userName = localStorage.getItem('userName');
  function getFirstLetter(str) {
    return str.charAt(0);
  }
  function splitString(str) {
    return str.split(' ')[0];
}
  const firstLetter = getFirstLetter(Name?Name:'');
  const firstName = splitString(Name?Name:'');

     const removeToken = () => {
        // window.localStorage.clear();
        localStorage.removeItem('token')
        navigate("/");
        window.location.reload(false);
    };
    const ChangePassword = () => {
      navigate("/changePassword");
    };

return(
<div className={`profileDrawrer ${props.inactive ? "inactive" : " "}`}>
  <div className="profile-drawrer-image">
    {/* <img src={AVATAR} alt="avatar" /> */}
    <div className='name'>
      <h3>{firstLetter}</h3>
    </div>
    <div className="adminList">
      <ul>
        <li>{firstName}</li>
        <li>{userName}</li>
      </ul>
    </div>
  </div>
  <div className="profile-drawrer-list">
    <ul className="">
      <li onClick={ChangePassword}>
        Change Password
      </li>
      <li onClick={removeToken}>
        Signin Another Account
      </li>
      {/* <li>
        <svg>
          <use href="#settings" />
        </svg>
        Settings
      </li> */}
    </ul>
  </div>
  <div className="profileLogout">
    <span onClick={removeToken}>
      Logout
    </span>
  </div>
  <div className="profilePrivacy">
    <li>Privacy Policy</li>
    <li>Terms of Service</li>
  </div>
</div>

);
}
export default Profile;